import React from 'react'
import { useContext } from './Context'

export const ErrorDisplay = () => {
  const { status, error } = useContext()
  const _error = status?.errorSending?.message ?? status?.errorSending ?? error
  return <div className="text-danger">{_error}</div>
}
